export function Footer() {
  return (
    <footer className="wf-footer">
      <div className="wf-footer-main">
        <div>made for groups who can never agree on a date</div>
        <div className="row" style={{ gap: 18 }}>
          <span>no sign-up</span>
          <span>·</span>
          <span>free forever</span>
        </div>
      </div>
      <div className="wf-footer-legal">
        © 2026{' '}
        <a href="https://venix.ltd/" target="_blank" rel="noopener noreferrer">
          Venix Holdings LTD
        </a>
        . All rights reserved.
      </div>
    </footer>
  );
}
